export default __webpack_public_path__ + "static/media/217-niraj-srivastava-0325_pages-to-jpg-0001.82fd2d1e.jpg";